<script>
  import {
    onInvalid,
    onChange,
    onBlur,
  } from '../lib/formcomponents/eventHandlers';

  import FormField from './FormField.svelte';

  export let name = '';
  export let id = '';
  export let value = '';
  export let label = '';
  export let required = false;
  export let style = '';
  export let errormessage = '';
</script>

<FormField {required} {style}>
  <input
    type="text"
    {name}
    id={id || name}
    bind:value
    {...$$props}
    placeholder={label}
    aria-required={required}
    {required}
    class="pristine"
    on:blur={onBlur}
    on:invalid={onInvalid}
    on:change={onChange}
  />
  <label for={id || name}>{label}</label>
  <div class="error" id={id || name}>
    {errormessage}
  </div>
</FormField>
